import axiosInstance from "../axiosInstance";

const BASE_URL = "/finance/dashboard";

export const getFinanceDashboard = async (params = {}) => {
  const response = await axiosInstance.get(BASE_URL, {
    params,
    withCredentials: true,
  });
  return response.data;
};
